import React from 'react'
import { Popover } from '@headlessui/react'
import { Link } from 'react-router-dom'
const LoginNav = () => {
  return (
    <div className='relative'>
      <div className='z-10 lg:w-full'>
        <Popover>
          <div className='relative pt-6 px-4 sm:px-6 lg:px-8'>
            <nav
              className='w-full relative flex items-center justify-between sm:h-10'
              aria-label='Global'
            >
              <div className='flex items-center flex-grow flex-shrink-0 lg:flex-grow-0'>
                <div className='flex items-center justify-between w-full md:w-auto'>
                  <Link to='/' className='flex items-center cursor-pointer'>
                    <img
                      className='h-8 w-auto sm:h-10'
                      src='/logo.png'
                      alt='Oya!'
                    />
                    <span className='pl-2 font-bold text-3xl'>Oya</span>
                  </Link>
                </div>
              </div>
            </nav>
          </div>
        </Popover>
      </div>
    </div>
  )
}

export default LoginNav
